import { ProductKind } from 'constants/product'

export const PreferredPaymentMethodEnum = {
  [ProductKind.SEPA_DIRECT_DEBIT]: ProductKind.SEPA_DIRECT_DEBIT,
  [ProductKind.CARD_PAYMENT]: ProductKind.CARD_PAYMENT,
  [ProductKind.INVOICE_BY_EMAIL]: ProductKind.INVOICE_BY_EMAIL,
  [ProductKind.NONE]: ProductKind.NONE,
} as const
